import { Col, Drawer, Grid, Row, Typography } from "antd";
import { useMemo, useState } from "react";
import ContactForm from "../ContactForm/ContactForm";
import DisplayPic from "../../../assets/display-picture.svg";
import styles from "./Introduction.module.less";

const { Title } = Typography;

const Introduction = () => {
  const [drawer, setDrawer] = useState(false);

  const openDrawer: React.MouseEventHandler<HTMLElement> = () => {
    setDrawer(true);
  };

  const { useBreakpoint } = Grid;
  const breakpoints = useBreakpoint();

  /**
   * @memorized value for display picture sizes width according to screen
   */
  const image_col_span: number = useMemo(() => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "xxl":
        return 6;
      case "md":
        return 8;
      // case "sm":
      //   return 24 / 1;
      case "xs":
        return 8;
      default:
        return 8;
    }
  }, [breakpoints]);

  /**
   * @memorized value for heading sizes width according to screen
   */
  const heading_col_span: number = useMemo(() => {
    const screens = Object.entries(breakpoints).filter((screen) => !!screen[1]);
    const screen_size = screens[screens.length - 1]?.[0];
    switch (screen_size) {
      case "xxl":
        return 16;
      case "lg":
        return 16;
      case "md":
        return 16;
      case "sm":
        return 16;
      case "xs":
        return 16;
      default:
        return 16;
    }
  }, [breakpoints]);

  return (
    <>
      <Row align={"middle"} justify={"start"}>
        <Col span={image_col_span}>
          <img src={DisplayPic} alt={"self"} className={styles.display_pic} />
        </Col>
        <Col span={heading_col_span}>
          <Title level={2}>Muhammad Zohaib Imtiaz</Title>
          <h3>FullStack Software Engineer</h3>
          {/* <Button type="primary" shape="round" onClick={openDrawer}>
            Contact me
          </Button> */}
          <h6>Select the cards below to see further information</h6>
        </Col>
        {/* <Col>
          <a href="/Resume.pdf" download="Resume" target='_blank'>
            <Button type="primary" shape="round">
              Download CV
              <DownloadOutlined />
            </Button>
          </a>
        </Col> */}
      </Row>
      <Drawer
        title="Contact"
        width={"100%"}
        closable={true}
        onClose={() => {
          setDrawer(false);
        }}
        visible={drawer}
      >
        <ContactForm />
      </Drawer>
    </>
  );
};

export default Introduction;
